import { ComponentPropsWithRef, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";
import classNames from "classnames";
interface Props extends PropsWithChildren<ComponentPropsWithRef<"input">> {
  value: string | undefined;
  set: (value: string) => void;
  placeholder?: string;
  pill?: boolean;
}

const DatePicker = (props: Props) => {
  const { pill, set, ...oriProps } = props;

  return (
    <input
      type="text"
      className={twMerge(
        classNames(
          "block w-full rounded-lg max-w-xl text-sm text-gray-900 border border-gray-200 appearance-none focus:outline-none focus:border-transparent focus:ring-2 peer cursor-pointer",
          pill ? "rounded-full p-4" : "px-2.5 pb-2.5 pt-3",
          props.className
        )
      )}
      placeholder={props.placeholder}
      onChange={(e) => set(e.target.value)}
      onClick={(e) => {
        e.currentTarget.type = "date";
        e.currentTarget.showPicker();
      }}
      onBlur={(e) => {
        if (!e.target.value) {
          e.target.type = "text";
        }
      }}
      {...oriProps}
    />
  );
};

export default DatePicker;
